import type { HeroPick } from '~/server/utils/properties/images/pickLandscapeHero';

// Client-side cache of server-resolved landscape heroes, keyed by project
// complex_id. Module-level so every ProjectCard + the /explore page share one
// map — a project is only ever resolved once per session.
const heroMap = ref<Record<string, HeroPick>>({});

export type HeroSource = { id: string; images: string[] };

export const useLandscapeHeroes = () => {
  // DISABLED for now. Project-wide we lead with the first image (index 0) /
  // hero_selected straight from the server mapper, instead of re-picking the
  // widest landscape still — the widest-pick overrode the intended first image.
  // resolveHeroes is a no-op, so `heroMap` stays empty → heroFor() returns
  // undefined → :hero-override is null → cards fall back to their `photo`.
  // Re-enable by restoring the POST to /api/properties/v2/landscape-heroes.
  const resolveHeroes = async (_sources: HeroSource[]) => {};

  return { heroMap: readonly(heroMap), resolveHeroes };
};
